/**
 * v-permission 自定义指令
 * 用于根据权限动态显示/隐藏元素
 *
 * 用法:
 * 1. 角色权限: v-permission="'message.forward'"
 * 2. 全局配置: v-permission="{type: 'config', key: 'session.topLimit', check: 'gt0'}"
 * 3. 群组权限: v-permission="{type: 'group', id: groupId, perm: 'isAllowViewMemberProfile'}"
 */

import {
	hasRolePermission,
	getGlobalConfig,
	hasGroupPermission
} from '../../api/permission.js';

export default {
	/**
	 * 指令绑定到元素时调用
	 */
	bind(el, binding) {
		checkPermission(el, binding);
	},

	/**
	 * 指令所在组件的 VNode 更新时调用
	 */
	update(el, binding) {
		checkPermission(el, binding);
	}
};

/**
 * 检查权限并显示/隐藏元素
 */
function checkPermission(el, binding) {
	const value = binding.value;
	let hasPermission = false;

	if (typeof value === 'string') {
		// 简单用法: v-permission="'message.forward'"
		// 检查角色权限
		hasPermission = hasRolePermission(value);
	} else if (typeof value === 'object') {
		// 对象用法: v-permission="{type, ...}"
		const { type, key, id, perm, check } = value;

		if (type === 'config') {
			// 全局配置检查
			const configValue = getGlobalConfig(key);

			if (check === 'gt0') {
				// 检查是否大于0
				hasPermission = configValue > 0;
			} else if (check === 'eq0') {
				// 检查是否等于0
				hasPermission = configValue === 0;
			} else if (check === 'true') {
				// 检查是否为true
				hasPermission = configValue === true;
			} else if (check === 'false') {
				// 检查是否为false
				hasPermission = configValue === false;
			} else {
				// 默认检查是否存在且不为falsy
				hasPermission = !!configValue;
			}
		} else if (type === 'group') {
			// 群组权限检查
			hasPermission = hasGroupPermission(id, perm);
		} else if (type === 'role') {
			// 角色权限检查(对象方式)
			hasPermission = hasRolePermission(key || perm);
		}
	}

	// 根据权限显示/隐藏元素
	if (hasPermission) {
		// 有权限,显示元素
		el.style.display = '';
	} else {
		// 无权限,隐藏元素
		el.style.display = 'none';
	}
}
